import { render, staticRenderFns } from "./ValidacaoComponent.vue?vue&type=template&id=751e98a7&scoped=true&lang=pug"
import script from "./ValidacaoComponent.vue?vue&type=script&lang=js"
export * from "./ValidacaoComponent.vue?vue&type=script&lang=js"
import style0 from "./ValidacaoComponent.vue?vue&type=style&index=0&id=751e98a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751e98a7",
  null
  
)

export default component.exports